<template>
    <section>
        <div v-if="loading">
            <Loading />
        </div>
        <div v-else>
            <ProfileNav />
            <MedalProfile :model="item" />
            <div id="cards" class="card-container">
                <h2>{{ $t('medal_detail_page.related_recipients_title') }}</h2>
                <ul class="cards" v-if="recipients.length > 0 && recipients[0] !== false"
                    :class="{'grid': recipients.length > 1, 'small-grid': recipients.length < 4}">
                    <RecipientCard v-for="recipient in recipients" v-bind:key="recipient.irn" :model="recipient" />
                </ul>
                <div v-else-if="recipients.length < 1" ><Loading style="height:200px" /></div>
                <p v-else class="no-recipients">{{ $t('medal_detail_page.no_recipients') }}</p>
            </div>
        </div>
    </section>
</template>

<script>
import { mapGetters } from 'vuex'

import Loading from '@/components/Loading'
import MedalProfile from '@/components/MedalProfile'
import ProfileNav from "@/components/ProfileNav"
import RecipientCard from "@/components/RecipientCard"

export default {
    components: {
        Loading,
        MedalProfile,
        RecipientCard,
        ProfileNav
    },
    computed: {
        ...mapGetters({
            'item': 'medals/item',
            'loading': 'medals/item_loading',
            'recipients': 'medals/recipients',
            'recipients_loading': 'medals/recipients_loading'
        }),
        meta_description() {
            return this.item ? this.item.summary.slice(0,100) + '...' : '';
        },
        meta_img () {
            return this.item ? this.item.image : '';
        },
        meta_title() {
            return this.item ? this.item.name : '-'
        }
    },
    head: {
        title: function() {
            return {
                inner: this.meta_title,
                separator: '|',
                complement: this.$i18n.t('main.museum_name')
            }
        },
        meta: function() {
            return [
                {rel: 'canonical', href: this.$i18n.t('main.cannonical'), id: 'rel-con'},
                {rel: 'alternate', href: this.$i18n.t('main.alternate'), hreflang: this.$i18n.t('main.alternate_locale'), id: 'rel-alt'},

                {name: 'description', content: this.meta_description, id: 'desc'},

                {property: 'og:title', content: `${this.meta_title} | ${this.$i18n.t('main.museum_name')}`, id: 'og-title'},
                {property: 'og:description', content: this.meta_description, id: 'og-desc'},
                {property: 'og:type', content: 'website', id: 'og-type'},
                {property: 'og:locale', content: this.$i18n.locale, id: 'og-locale'},
                {property: 'og:image', content: `${window.location.host}${this.meta_img}`, id: 'og-image'}
            ]
        }
    },
    async beforeDestroy() {
        await this.$store.dispatch("medals/null_item")
    },
    async mounted() {
        setTimeout(() => {
            document.querySelector('html').scrollTop = 0;
        }, 100);
        await this.$store.dispatch("medals/fetch_list", {
            locale: this.$i18n.locale
        })
        await this.$store.dispatch("medals/fetch", {
            locale: this.$i18n.locale,
            slug: this.$route.params.slug
        })

        this.$emit('updateHead')
    }
}
</script>
